export default {"src":"/_next/static/media/qualifying-item-badge-3.c6420640.svg","height":152,"width":152,"blurWidth":0,"blurHeight":0};